import React from 'react';
import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import PageTitle from '../../components/PageTitle';
import Message from '../../components/Message';
import { SimpleLoadingComponent } from '../../utils/apollo';

const messages = defineMessages({
  navianceMessage: {
    id: 'repvisits.unauthorized.navianceMessage',
    defaultMessage: 'To access RepVisits, please have your school site manager change your user role to "Administer Counselor Community." User roles can be adjusted within Naviance by going to {link}.',
  },
  nonNavianceMessage: {
    id: 'repvisits.unauthorized.nonNavianceMessage',
    defaultMessage: 'To access RepVisits, you will need to have your role changed to "Administer Counselor Community." Please contact support for assistance: {link}.',
  },
  navianceLink: {
    id: 'repvisits.unauthorized.link',
    defaultMessage: 'Setup > User Admin > Manage Roles and Rights',
  },
});

export const RepVisitsUnauthorizedPageComponent = ({ viewer: { isNavianceLogin } }) => (
  <div>
    <PageTitle title="RepVisits" category="Presence" />
    <Message negative>
      <p>
        {isNavianceLogin ? (
          <FormattedMessage
            {...messages.navianceMessage}
            values={{ link: <strong><FormattedMessage {...messages.navianceLink} /></strong> }}
          />
        ): (
          <FormattedMessage
            {...messages.nonNavianceMessage}
            values={{ link: <a href={`mailto:${process.env.COUNSELOR_COMMUNITY_EMAIL}`}>{process.env.COUNSELOR_COMMUNITY_EMAIL}</a> }}
          />
        )}
      </p>
    </Message>
  </div>
);
RepVisitsUnauthorizedPageComponent.propTypes = {
  viewer: PropTypes.object,
};

const query = gql`
  query RepVisitsUnauthorizedPage {
    viewer {
      id
      isNavianceLogin
    }
  }
`;
const graphqlData = graphql(query);
export default SimpleLoadingComponent(graphqlData)(RepVisitsUnauthorizedPageComponent);
